module.exports = __webpack_public_path__ + "static/img/exhibitImage4.b1fbed7c.jpg";